import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div
      data-testid="payment-cancel-page"
      className="min-h-screen bg-[color:var(--sr-bg)] pt-32 md:pt-40 pb-24"
    >
      <div className="sr-container max-w-3xl">
        <p className="label-eyebrow text-[color:var(--sr-primary)] mb-6 flex items-center gap-3">
          <span className="w-8 h-px bg-[color:var(--sr-accent)]" /> Checkout cancelled
        </p>
        <h1 className="font-serif text-6xl md:text-8xl leading-[0.9] tracking-tight text-[color:var(--sr-primary)]">
          No hurry.
          <br />
          <em className="italic font-light text-[color:var(--sr-accent)]">
            Your bag is waiting.
          </em>
        </h1>
        <p className="mt-8 text-[color:var(--sr-text)]/75 leading-relaxed max-w-md">
          Nothing was charged. Your bag has been saved — return whenever
          you&apos;re ready.
        </p>
        <div className="mt-14 flex flex-wrap gap-4">
          <Link
            to="/shop"
            data-testid="return-shop-btn"
            className="inline-flex items-center gap-3 px-8 py-4 bg-[color:var(--sr-primary)] text-[color:var(--sr-secondary)] label-eyebrow hover:bg-[color:var(--sr-primary-deep)] transition-colors"
          >
            Return to shop
            <ArrowRight size={16} strokeWidth={1.25} />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-3 px-8 py-4 label-eyebrow text-[color:var(--sr-primary)] hover:text-[color:var(--sr-accent)] transition-colors"
          >
            Return home
          </Link>
        </div>
      </div>
    </div>
  );
}
